module.exports = __webpack_public_path__ + "static/media/pool.a7043f46.svg";